var At = Object.defineProperty, Bt = Object.defineProperties;
var Wt = Object.getOwnPropertyDescriptors;
var ue = Object.getOwnPropertySymbols;
var Xe = Object.prototype.hasOwnProperty, Ye = Object.prototype.propertyIsEnumerable;
var _e = (e, t, r) => t in e ? At(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, E = (e, t) => {
  for (var r in t || (t = {}))
    Xe.call(t, r) && _e(e, r, t[r]);
  if (ue)
    for (var r of ue(t))
      Ye.call(t, r) && _e(e, r, t[r]);
  return e;
}, I = (e, t) => Bt(e, Wt(t));
var z = (e, t) => {
  var r = {};
  for (var n in e)
    Xe.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && ue)
    for (var n of ue(e))
      t.indexOf(n) < 0 && Ye.call(e, n) && (r[n] = e[n]);
  return r;
};
import B, { useRef as C, useCallback as k, useState as D, useContext as ee, useEffect as V, useMemo as Y, createContext as Ae, forwardRef as lt, Fragment as Ut } from "react";
import { c as Be, e as st, s as dt, j as Ce } from "./formik-field-3c206abb.js";
import { Field as Rt } from "formik";
const te = typeof document != "undefined" ? B.useLayoutEffect : () => {
};
function H(e) {
  const t = C(null);
  return te(() => {
    t.current = e;
  }, [
    e
  ]), k((...r) => {
    const n = t.current;
    return n == null ? void 0 : n(...r);
  }, []);
}
function jt(e) {
  let [t, r] = D(e), n = C(null), a = H(() => {
    if (!n.current)
      return;
    let o = n.current.next();
    if (o.done) {
      n.current = null;
      return;
    }
    t === o.value ? a() : r(o.value);
  });
  te(() => {
    n.current && a();
  });
  let l = H((o) => {
    n.current = o(t), a();
  });
  return [
    t,
    l
  ];
}
const $e = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, ut = /* @__PURE__ */ B.createContext($e), Gt = /* @__PURE__ */ B.createContext(!1);
let Nt = !!(typeof window != "undefined" && window.document && window.document.createElement), we = /* @__PURE__ */ new WeakMap();
function qt(e = !1) {
  let t = ee(ut), r = C(null);
  if (r.current === null && !e) {
    var n, a;
    let l = (a = B.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || a === void 0 || (n = a.ReactCurrentOwner) === null || n === void 0 ? void 0 : n.current;
    if (l) {
      let o = we.get(l);
      o == null ? we.set(l, {
        id: t.current,
        state: l.memoizedState
      }) : l.memoizedState !== o.state && (t.current = o.id, we.delete(l));
    }
    r.current = ++t.current;
  }
  return r.current;
}
function _t(e) {
  let t = ee(ut);
  t === $e && !Nt && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let r = qt(!!e), n = `react-aria${t.prefix}`;
  return e || `${n}-${r}`;
}
function Xt(e) {
  let t = B.useId(), [r] = D(ct()), n = r ? "react-aria" : `react-aria${$e.prefix}`;
  return e || `${n}-${t}`;
}
const Yt = typeof B.useId == "function" ? Xt : _t;
function zt() {
  return !1;
}
function Qt() {
  return !0;
}
function Jt(e) {
  return () => {
  };
}
function ct() {
  return typeof B.useSyncExternalStore == "function" ? B.useSyncExternalStore(Jt, zt, Qt) : ee(Gt);
}
let Zt = !!(typeof window != "undefined" && window.document && window.document.createElement), X = /* @__PURE__ */ new Map();
function ge(e) {
  let [t, r] = D(e), n = C(null), a = Yt(t), l = k((o) => {
    n.current = o;
  }, []);
  return Zt && (X.has(a) && !X.get(a).includes(l) ? X.set(a, [
    ...X.get(a),
    l
  ]) : X.set(a, [
    l
  ])), te(() => {
    let o = a;
    return () => {
      X.delete(o);
    };
  }, [
    a
  ]), V(() => {
    let o = n.current;
    o && (n.current = null, r(o));
  }), a;
}
function er(e, t) {
  if (e === t)
    return e;
  let r = X.get(e);
  if (r)
    return r.forEach((a) => a(t)), t;
  let n = X.get(t);
  return n ? (n.forEach((a) => a(e)), e) : t;
}
function ze(e = []) {
  let t = ge(), [r, n] = jt(t), a = k(() => {
    n(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    n
  ]);
  return te(a, [
    t,
    a,
    ...e
  ]), r;
}
function ft(...e) {
  return (...t) => {
    for (let r of e)
      typeof r == "function" && r(...t);
  };
}
const K = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, R = (e) => e && "window" in e && e.window === e ? e : K(e).defaultView || window;
function A(...e) {
  let t = E({}, e[0]);
  for (let r = 1; r < e.length; r++) {
    let n = e[r];
    for (let a in n) {
      let l = t[a], o = n[a];
      typeof l == "function" && typeof o == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? t[a] = ft(l, o) : (a === "className" || a === "UNSAFE_className") && typeof l == "string" && typeof o == "string" ? t[a] = Be(l, o) : a === "id" && l && o ? t.id = er(l, o) : t[a] = o !== void 0 ? o : l;
    }
  }
  return t;
}
const tr = /* @__PURE__ */ new Set([
  "id"
]), rr = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), nr = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), ar = /^(data-.*)$/;
function We(e, t = {}) {
  let { labelable: r, isLink: n, propNames: a } = t, l = {};
  for (const o in e)
    Object.prototype.hasOwnProperty.call(e, o) && (tr.has(o) || r && rr.has(o) || n && nr.has(o) || a != null && a.has(o) || ar.test(o)) && (l[o] = e[o]);
  return l;
}
function Q(e) {
  if (ir())
    e.focus({
      preventScroll: !0
    });
  else {
    let t = or(e);
    e.focus(), lr(t);
  }
}
let ce = null;
function ir() {
  if (ce == null) {
    ce = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return ce = !0, !0;
        }
      });
    } catch (e) {
    }
  }
  return ce;
}
function or(e) {
  let t = e.parentNode, r = [], n = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== n; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && r.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return n instanceof HTMLElement && r.push({
    element: n,
    scrollTop: n.scrollTop,
    scrollLeft: n.scrollLeft
  }), r;
}
function lr(e) {
  for (let { element: t, scrollTop: r, scrollLeft: n } of e)
    t.scrollTop = r, t.scrollLeft = n;
}
function Pe(e) {
  var t;
  return typeof window == "undefined" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((r) => e.test(r.brand))) || e.test(window.navigator.userAgent);
}
function Ue(e) {
  var t;
  return typeof window != "undefined" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function q(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const oe = q(function() {
  return Ue(/^Mac/i);
}), sr = q(function() {
  return Ue(/^iPhone/i);
}), vt = q(function() {
  return Ue(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  oe() && navigator.maxTouchPoints > 1;
}), Re = q(function() {
  return sr() || vt();
}), ln = q(function() {
  return oe() || Re();
}), dr = q(function() {
  return Pe(/AppleWebKit/i) && !ur();
}), ur = q(function() {
  return Pe(/Chrome/i);
}), pt = q(function() {
  return Pe(/Android/i);
}), cr = q(function() {
  return Pe(/Firefox/i);
}), bt = /* @__PURE__ */ Ae({
  isNative: !0,
  open: vr,
  useHref: (e) => e
});
function sn(e) {
  let { children: t, navigate: r, useHref: n } = e, a = Y(() => ({
    isNative: !1,
    open: (l, o, s, u) => {
      gt(l, (c) => {
        fr(c, o) ? r(s, u) : J(c, o);
      });
    },
    useHref: n || ((l) => l)
  }), [
    r,
    n
  ]);
  return /* @__PURE__ */ B.createElement(bt.Provider, {
    value: a
  }, t);
}
function $t() {
  return ee(bt);
}
function fr(e, t) {
  let r = e.getAttribute("target");
  return (!r || r === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function J(e, t, r = !0) {
  var n, a;
  let { metaKey: l, ctrlKey: o, altKey: s, shiftKey: u } = t;
  cr() && (!((a = window.event) === null || a === void 0 || (n = a.type) === null || n === void 0) && n.startsWith("key")) && e.target === "_blank" && (oe() ? l = !0 : o = !0);
  let c = dr() && oe() && !vt() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: l,
    ctrlKey: o,
    altKey: s,
    shiftKey: u
  }) : new MouseEvent("click", {
    metaKey: l,
    ctrlKey: o,
    altKey: s,
    shiftKey: u,
    bubbles: !0,
    cancelable: !0
  });
  J.isOpening = r, Q(e), e.dispatchEvent(c), J.isOpening = !1;
}
J.isOpening = !1;
function gt(e, t) {
  if (e instanceof HTMLAnchorElement)
    t(e);
  else if (e.hasAttribute("data-href")) {
    let r = document.createElement("a");
    r.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (r.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (r.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (r.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (r.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (r.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(r), t(r), e.removeChild(r);
  }
}
function vr(e, t) {
  gt(e, (r) => J(r, t));
}
function dn(e) {
  let t = $t();
  var r;
  const n = t.useHref((r = e.href) !== null && r !== void 0 ? r : "");
  return {
    "data-href": e.href ? n : void 0,
    "data-target": e.target,
    "data-rel": e.rel,
    "data-download": e.download,
    "data-ping": e.ping,
    "data-referrer-policy": e.referrerPolicy
  };
}
function un(e) {
  let t = $t();
  var r;
  const n = t.useHref((r = e == null ? void 0 : e.href) !== null && r !== void 0 ? r : "");
  return {
    href: e != null && e.href ? n : void 0,
    target: e == null ? void 0 : e.target,
    rel: e == null ? void 0 : e.rel,
    download: e == null ? void 0 : e.download,
    ping: e == null ? void 0 : e.ping,
    referrerPolicy: e == null ? void 0 : e.referrerPolicy
  };
}
let ne = /* @__PURE__ */ new Map(), Ie = /* @__PURE__ */ new Set();
function Qe() {
  if (typeof window == "undefined")
    return;
  function e(n) {
    return "propertyName" in n;
  }
  let t = (n) => {
    if (!e(n) || !n.target)
      return;
    let a = ne.get(n.target);
    a || (a = /* @__PURE__ */ new Set(), ne.set(n.target, a), n.target.addEventListener("transitioncancel", r, {
      once: !0
    })), a.add(n.propertyName);
  }, r = (n) => {
    if (!e(n) || !n.target)
      return;
    let a = ne.get(n.target);
    if (a && (a.delete(n.propertyName), a.size === 0 && (n.target.removeEventListener("transitioncancel", r), ne.delete(n.target)), ne.size === 0)) {
      for (let l of Ie)
        l();
      Ie.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", r);
}
typeof document != "undefined" && (document.readyState !== "loading" ? Qe() : document.addEventListener("DOMContentLoaded", Qe));
function yt(e) {
  requestAnimationFrame(() => {
    ne.size === 0 ? e() : Ie.add(e);
  });
}
function pr() {
  let e = C(/* @__PURE__ */ new Map()), t = k((a, l, o, s) => {
    let u = s != null && s.once ? (...c) => {
      e.current.delete(o), o(...c);
    } : o;
    e.current.set(o, {
      type: l,
      eventTarget: a,
      fn: u,
      options: s
    }), a.addEventListener(l, o, s);
  }, []), r = k((a, l, o, s) => {
    var u;
    let c = ((u = e.current.get(o)) === null || u === void 0 ? void 0 : u.fn) || o;
    a.removeEventListener(l, c, s), e.current.delete(o);
  }, []), n = k(() => {
    e.current.forEach((a, l) => {
      r(a.eventTarget, a.type, l, a.options);
    });
  }, [
    r
  ]);
  return V(() => n, [
    n
  ]), {
    addGlobalListener: t,
    removeGlobalListener: r,
    removeAllGlobalListeners: n
  };
}
function br(e, t) {
  let { id: r, "aria-label": n, "aria-labelledby": a } = e;
  return r = ge(r), a && n ? a = [
    .../* @__PURE__ */ new Set([
      r,
      ...a.trim().split(/\s+/)
    ])
  ].join(" ") : a && (a = a.trim().split(/\s+/).join(" ")), !n && !a && t && (n = t), {
    id: r,
    "aria-label": n,
    "aria-labelledby": a
  };
}
function cn(e) {
  const t = C(null);
  return Y(() => ({
    get current() {
      return t.current;
    },
    set current(r) {
      t.current = r, typeof e == "function" ? e(r) : e && (e.current = r);
    }
  }), [
    e
  ]);
}
function mt(e, t) {
  te(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function Fe(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : pt() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function $r(e) {
  return !pt() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function ht(e, t, r) {
  let n = C(t), a = H(() => {
    r && r(n.current);
  });
  V(() => {
    var l;
    let o = e == null || (l = e.current) === null || l === void 0 ? void 0 : l.form;
    return o == null || o.addEventListener("reset", a), () => {
      o == null || o.removeEventListener("reset", a);
    };
  }, [
    e,
    a
  ]);
}
function Pt(e, t, r) {
  let [n, a] = D(e || t), l = C(e !== void 0), o = e !== void 0;
  V(() => {
    let c = l.current;
    c !== o && console.warn(`WARN: A component changed from ${c ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}.`), l.current = o;
  }, [
    o
  ]);
  let s = o ? e : n, u = k((c, ...b) => {
    let g = (m, ...$) => {
      r && (Object.is(s, m) || r(m, ...$)), o || (s = m);
    };
    typeof c == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), a(($, ...h) => {
      let y = c(o ? s : $, ...h);
      return g(y, ...b), o ? $ : y;
    })) : (o || a(c), g(c, ...b));
  }, [
    o,
    s,
    r
  ]);
  return [
    s,
    u
  ];
}
let ie = "default", Ve = "", be = /* @__PURE__ */ new WeakMap();
function Je(e) {
  if (Re()) {
    if (ie === "default") {
      const t = K(e);
      Ve = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    ie = "disabled";
  } else
    (e instanceof HTMLElement || e instanceof SVGElement) && (be.set(e, e.style.userSelect), e.style.userSelect = "none");
}
function fe(e) {
  if (Re()) {
    if (ie !== "disabled")
      return;
    ie = "restoring", setTimeout(() => {
      yt(() => {
        if (ie === "restoring") {
          const t = K(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = Ve || ""), Ve = "", ie = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && be.has(e)) {
    let t = be.get(e);
    e.style.userSelect === "none" && (e.style.userSelect = t), e.getAttribute("style") === "" && e.removeAttribute("style"), be.delete(e);
  }
}
const Et = B.createContext({
  register: () => {
  }
});
Et.displayName = "PressResponderContext";
function gr(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function Tt(e, t, r) {
  if (!t.has(e))
    throw new TypeError("attempted to " + r + " private field on non-instance");
  return t.get(e);
}
function yr(e, t) {
  var r = Tt(e, t, "get");
  return gr(e, r);
}
function mr(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function hr(e, t, r) {
  mr(e, t), t.set(e, r);
}
function Pr(e, t, r) {
  if (t.set)
    t.set.call(e, r);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = r;
  }
}
function Ze(e, t, r) {
  var n = Tt(e, t, "set");
  return Pr(e, n, r), r;
}
function Er(e) {
  let t = ee(Et);
  if (t) {
    let r = t, { register: n } = r, a = z(r, ["register"]);
    e = A(a, e), n();
  }
  return mt(t, e.ref), e;
}
var ve = /* @__PURE__ */ new WeakMap();
class pe {
  continuePropagation() {
    Ze(this, ve, !1);
  }
  get shouldStopPropagation() {
    return yr(this, ve);
  }
  constructor(t, r, n, a) {
    hr(this, ve, {
      writable: !0,
      value: void 0
    }), Ze(this, ve, !0);
    var l;
    let o = (l = a == null ? void 0 : a.target) !== null && l !== void 0 ? l : n.currentTarget;
    const s = o == null ? void 0 : o.getBoundingClientRect();
    let u, c = 0, b, g = null;
    n.clientX != null && n.clientY != null && (b = n.clientX, g = n.clientY), s && (b != null && g != null ? (u = b - s.left, c = g - s.top) : (u = s.width / 2, c = s.height / 2)), this.type = t, this.pointerType = r, this.target = n.currentTarget, this.shiftKey = n.shiftKey, this.metaKey = n.metaKey, this.ctrlKey = n.ctrlKey, this.altKey = n.altKey, this.x = u, this.y = c;
  }
}
const et = Symbol("linkClicked");
function De(e) {
  let Te = Er(e), {
    onPress: t,
    onPressChange: r,
    onPressStart: n,
    onPressEnd: a,
    onPressUp: l,
    isDisabled: o,
    isPressed: s,
    preventFocusOnPress: u,
    shouldCancelOnPointerExit: c,
    allowTextSelectionOnPress: b,
    ref: g
  } = Te, m = z(Te, [
    "onPress",
    "onPressChange",
    "onPressStart",
    "onPressEnd",
    "onPressUp",
    "isDisabled",
    "isPressed",
    "preventFocusOnPress",
    "shouldCancelOnPointerExit",
    "allowTextSelectionOnPress",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    "ref"
  ]), [$, h] = D(!1), y = C({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: T, removeAllGlobalListeners: F } = pr(), x = H((i, p) => {
    let U = y.current;
    if (o || U.didFirePressStart)
      return !1;
    let v = !0;
    if (U.isTriggeringEvent = !0, n) {
      let S = new pe("pressstart", p, i);
      n(S), v = S.shouldStopPropagation;
    }
    return r && r(!0), U.isTriggeringEvent = !1, U.didFirePressStart = !0, h(!0), v;
  }), w = H((i, p, U = !0) => {
    let v = y.current;
    if (!v.didFirePressStart)
      return !1;
    v.ignoreClickAfterPress = !0, v.didFirePressStart = !1, v.isTriggeringEvent = !0;
    let S = !0;
    if (a) {
      let d = new pe("pressend", p, i);
      a(d), S = d.shouldStopPropagation;
    }
    if (r && r(!1), h(!1), t && U && !o) {
      let d = new pe("press", p, i);
      t(d), S && (S = d.shouldStopPropagation);
    }
    return v.isTriggeringEvent = !1, S;
  }), L = H((i, p) => {
    let U = y.current;
    if (o)
      return !1;
    if (l) {
      U.isTriggeringEvent = !0;
      let v = new pe("pressup", p, i);
      return l(v), U.isTriggeringEvent = !1, v.shouldStopPropagation;
    }
    return !0;
  }), M = H((i) => {
    let p = y.current;
    p.isPressed && p.target && (p.isOverTarget && p.pointerType != null && w(G(p.target, i), p.pointerType, !1), p.isPressed = !1, p.isOverTarget = !1, p.activePointerId = null, p.pointerType = null, F(), b || fe(p.target));
  }), W = H((i) => {
    c && M(i);
  }), le = Y(() => {
    let i = y.current, p = {
      onKeyDown(v) {
        if (Se(v.nativeEvent, v.currentTarget) && v.currentTarget.contains(v.target)) {
          var S;
          rt(v.target, v.key) && v.preventDefault();
          let d = !0;
          if (!i.isPressed && !v.repeat) {
            i.target = v.currentTarget, i.isPressed = !0, d = x(v, "keyboard");
            let P = v.currentTarget, f = (j) => {
              Se(j, P) && !j.repeat && P.contains(j.target) && i.target && L(G(i.target, j), "keyboard");
            };
            T(K(v.currentTarget), "keyup", ft(f, U), !0);
          }
          d && v.stopPropagation(), v.metaKey && oe() && ((S = i.metaKeyEvents) === null || S === void 0 || S.set(v.key, v.nativeEvent));
        } else
          v.key === "Meta" && (i.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(v) {
        if (!(v && !v.currentTarget.contains(v.target)) && v && v.button === 0 && !i.isTriggeringEvent && !J.isOpening) {
          let S = !0;
          if (o && v.preventDefault(), !i.ignoreClickAfterPress && !i.ignoreEmulatedMouseEvents && !i.isPressed && (i.pointerType === "virtual" || Fe(v.nativeEvent))) {
            !o && !u && Q(v.currentTarget);
            let d = x(v, "virtual"), P = L(v, "virtual"), f = w(v, "virtual");
            S = d && P && f;
          }
          i.ignoreEmulatedMouseEvents = !1, i.ignoreClickAfterPress = !1, S && v.stopPropagation();
        }
      }
    }, U = (v) => {
      var S;
      if (i.isPressed && i.target && Se(v, i.target)) {
        var d;
        rt(v.target, v.key) && v.preventDefault();
        let f = v.target;
        w(G(i.target, v), "keyboard", i.target.contains(f)), F(), v.key !== "Enter" && je(i.target) && i.target.contains(f) && !v[et] && (v[et] = !0, J(i.target, v, !1)), i.isPressed = !1, (d = i.metaKeyEvents) === null || d === void 0 || d.delete(v.key);
      } else if (v.key === "Meta" && (!((S = i.metaKeyEvents) === null || S === void 0) && S.size)) {
        var P;
        let f = i.metaKeyEvents;
        i.metaKeyEvents = void 0;
        for (let j of f.values())
          (P = i.target) === null || P === void 0 || P.dispatchEvent(new KeyboardEvent("keyup", j));
      }
    };
    if (typeof PointerEvent != "undefined") {
      p.onPointerDown = (f) => {
        if (f.button !== 0 || !f.currentTarget.contains(f.target))
          return;
        if ($r(f.nativeEvent)) {
          i.pointerType = "virtual";
          return;
        }
        xe(f.currentTarget) && f.preventDefault(), i.pointerType = f.pointerType;
        let j = !0;
        i.isPressed || (i.isPressed = !0, i.isOverTarget = !0, i.activePointerId = f.pointerId, i.target = f.currentTarget, !o && !u && Q(f.currentTarget), b || Je(i.target), j = x(f, i.pointerType), T(K(f.currentTarget), "pointermove", v, !1), T(K(f.currentTarget), "pointerup", S, !1), T(K(f.currentTarget), "pointercancel", P, !1)), j && f.stopPropagation();
      }, p.onMouseDown = (f) => {
        f.currentTarget.contains(f.target) && f.button === 0 && (xe(f.currentTarget) && f.preventDefault(), f.stopPropagation());
      }, p.onPointerUp = (f) => {
        !f.currentTarget.contains(f.target) || i.pointerType === "virtual" || f.button === 0 && re(f, f.currentTarget) && L(f, i.pointerType || f.pointerType);
      };
      let v = (f) => {
        f.pointerId === i.activePointerId && (i.target && re(f, i.target) ? !i.isOverTarget && i.pointerType != null && (i.isOverTarget = !0, x(G(i.target, f), i.pointerType)) : i.target && i.isOverTarget && i.pointerType != null && (i.isOverTarget = !1, w(G(i.target, f), i.pointerType, !1), W(f)));
      }, S = (f) => {
        f.pointerId === i.activePointerId && i.isPressed && f.button === 0 && i.target && (re(f, i.target) && i.pointerType != null ? w(G(i.target, f), i.pointerType) : i.isOverTarget && i.pointerType != null && w(G(i.target, f), i.pointerType, !1), i.isPressed = !1, i.isOverTarget = !1, i.activePointerId = null, i.pointerType = null, F(), b || fe(i.target), "ontouchend" in i.target && f.pointerType !== "mouse" && T(i.target, "touchend", d, {
          once: !0
        }));
      }, d = (f) => {
        wt(f.currentTarget) && f.preventDefault();
      }, P = (f) => {
        M(f);
      };
      p.onDragStart = (f) => {
        f.currentTarget.contains(f.target) && M(f);
      };
    } else {
      p.onMouseDown = (d) => {
        if (d.button !== 0 || !d.currentTarget.contains(d.target))
          return;
        if (xe(d.currentTarget) && d.preventDefault(), i.ignoreEmulatedMouseEvents) {
          d.stopPropagation();
          return;
        }
        i.isPressed = !0, i.isOverTarget = !0, i.target = d.currentTarget, i.pointerType = Fe(d.nativeEvent) ? "virtual" : "mouse", !o && !u && Q(d.currentTarget), x(d, i.pointerType) && d.stopPropagation(), T(K(d.currentTarget), "mouseup", v, !1);
      }, p.onMouseEnter = (d) => {
        if (!d.currentTarget.contains(d.target))
          return;
        let P = !0;
        i.isPressed && !i.ignoreEmulatedMouseEvents && i.pointerType != null && (i.isOverTarget = !0, P = x(d, i.pointerType)), P && d.stopPropagation();
      }, p.onMouseLeave = (d) => {
        if (!d.currentTarget.contains(d.target))
          return;
        let P = !0;
        i.isPressed && !i.ignoreEmulatedMouseEvents && i.pointerType != null && (i.isOverTarget = !1, P = w(d, i.pointerType, !1), W(d)), P && d.stopPropagation();
      }, p.onMouseUp = (d) => {
        d.currentTarget.contains(d.target) && !i.ignoreEmulatedMouseEvents && d.button === 0 && L(d, i.pointerType || "mouse");
      };
      let v = (d) => {
        if (d.button === 0) {
          if (i.isPressed = !1, F(), i.ignoreEmulatedMouseEvents) {
            i.ignoreEmulatedMouseEvents = !1;
            return;
          }
          i.target && re(d, i.target) && i.pointerType != null ? w(G(i.target, d), i.pointerType) : i.target && i.isOverTarget && i.pointerType != null && w(G(i.target, d), i.pointerType, !1), i.isOverTarget = !1;
        }
      };
      p.onTouchStart = (d) => {
        if (!d.currentTarget.contains(d.target))
          return;
        let P = Tr(d.nativeEvent);
        if (!P)
          return;
        i.activePointerId = P.identifier, i.ignoreEmulatedMouseEvents = !0, i.isOverTarget = !0, i.isPressed = !0, i.target = d.currentTarget, i.pointerType = "touch", !o && !u && Q(d.currentTarget), b || Je(i.target), x(_(i.target, d), i.pointerType) && d.stopPropagation(), T(R(d.currentTarget), "scroll", S, !0);
      }, p.onTouchMove = (d) => {
        if (!d.currentTarget.contains(d.target))
          return;
        if (!i.isPressed) {
          d.stopPropagation();
          return;
        }
        let P = tt(d.nativeEvent, i.activePointerId), f = !0;
        P && re(P, d.currentTarget) ? !i.isOverTarget && i.pointerType != null && (i.isOverTarget = !0, f = x(_(i.target, d), i.pointerType)) : i.isOverTarget && i.pointerType != null && (i.isOverTarget = !1, f = w(_(i.target, d), i.pointerType, !1), W(_(i.target, d))), f && d.stopPropagation();
      }, p.onTouchEnd = (d) => {
        if (!d.currentTarget.contains(d.target))
          return;
        if (!i.isPressed) {
          d.stopPropagation();
          return;
        }
        let P = tt(d.nativeEvent, i.activePointerId), f = !0;
        P && re(P, d.currentTarget) && i.pointerType != null ? (L(_(i.target, d), i.pointerType), f = w(_(i.target, d), i.pointerType)) : i.isOverTarget && i.pointerType != null && (f = w(_(i.target, d), i.pointerType, !1)), f && d.stopPropagation(), i.isPressed = !1, i.activePointerId = null, i.isOverTarget = !1, i.ignoreEmulatedMouseEvents = !0, i.target && !b && fe(i.target), F();
      }, p.onTouchCancel = (d) => {
        d.currentTarget.contains(d.target) && (d.stopPropagation(), i.isPressed && M(_(i.target, d)));
      };
      let S = (d) => {
        i.isPressed && d.target.contains(i.target) && M({
          currentTarget: i.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      p.onDragStart = (d) => {
        d.currentTarget.contains(d.target) && M(d);
      };
    }
    return p;
  }, [
    T,
    o,
    u,
    F,
    b,
    M,
    W,
    w,
    x,
    L
  ]);
  return V(() => () => {
    var i;
    b || fe((i = y.current.target) !== null && i !== void 0 ? i : void 0);
  }, [
    b
  ]), {
    isPressed: s || $,
    pressProps: A(m, le)
  };
}
function je(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function Se(e, t) {
  const { key: r, code: n } = e, a = t, l = a.getAttribute("role");
  return (r === "Enter" || r === " " || r === "Spacebar" || n === "Space") && !(a instanceof R(a).HTMLInputElement && !St(a, r) || a instanceof R(a).HTMLTextAreaElement || a.isContentEditable) && // Links should only trigger with Enter key
  !((l === "link" || !l && je(a)) && r !== "Enter");
}
function Tr(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function tt(e, t) {
  const r = e.changedTouches;
  for (let n = 0; n < r.length; n++) {
    const a = r[n];
    if (a.identifier === t)
      return a;
  }
  return null;
}
function _(e, t) {
  let r = 0, n = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (r = t.targetTouches[0].clientX, n = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: r,
    clientY: n
  };
}
function G(e, t) {
  let r = t.clientX, n = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: r,
    clientY: n
  };
}
function wr(e) {
  let t = 0, r = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? r = e.height / 2 : e.radiusY !== void 0 && (r = e.radiusY), {
    top: e.clientY - r,
    right: e.clientX + t,
    bottom: e.clientY + r,
    left: e.clientX - t
  };
}
function Sr(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function re(e, t) {
  let r = t.getBoundingClientRect(), n = wr(e);
  return Sr(r, n);
}
function xe(e) {
  return !(e instanceof HTMLElement) || !e.hasAttribute("draggable");
}
function wt(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !je(e);
}
function rt(e, t) {
  return e instanceof HTMLInputElement ? !St(e, t) : wt(e);
}
const xr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function St(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : xr.has(e.type);
}
class Mr {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, r) {
    this.nativeEvent = r, this.target = r.target, this.currentTarget = r.currentTarget, this.relatedTarget = r.relatedTarget, this.bubbles = r.bubbles, this.cancelable = r.cancelable, this.defaultPrevented = r.defaultPrevented, this.eventPhase = r.eventPhase, this.isTrusted = r.isTrusted, this.timeStamp = r.timeStamp, this.type = t;
  }
}
function xt(e) {
  let t = C({
    isFocused: !1,
    observer: null
  });
  te(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []);
  let r = H((n) => {
    e == null || e(n);
  });
  return k((n) => {
    if (n.target instanceof HTMLButtonElement || n.target instanceof HTMLInputElement || n.target instanceof HTMLTextAreaElement || n.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = n.target, l = (o) => {
        t.current.isFocused = !1, a.disabled && r(new Mr("blur", o)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", l, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var o;
          (o = t.current.observer) === null || o === void 0 || o.disconnect();
          let s = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
function Mt(e) {
  let { isDisabled: t, onFocus: r, onBlur: n, onFocusChange: a } = e;
  const l = k((u) => {
    if (u.target === u.currentTarget)
      return n && n(u), a && a(!1), !0;
  }, [
    n,
    a
  ]), o = xt(l), s = k((u) => {
    const c = K(u.target);
    u.target === u.currentTarget && c.activeElement === u.target && (r && r(u), a && a(!0), o(u));
  }, [
    a,
    r,
    o
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || a || n) ? s : void 0,
      onBlur: !t && (n || a) ? l : void 0
    }
  };
}
let N = null, de = /* @__PURE__ */ new Set(), se = /* @__PURE__ */ new Map(), Z = !1, ke = !1;
const Lr = {
  Tab: !0,
  Escape: !0
};
function Ee(e, t) {
  for (let r of de)
    r(e, t);
}
function Cr(e) {
  return !(e.metaKey || !oe() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function ye(e) {
  Z = !0, Cr(e) && (N = "keyboard", Ee("keyboard", e));
}
function O(e) {
  N = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (Z = !0, Ee("pointer", e));
}
function Lt(e) {
  Fe(e) && (Z = !0, N = "virtual");
}
function Ct(e) {
  e.target === window || e.target === document || (!Z && !ke && (N = "virtual", Ee("virtual", e)), Z = !1, ke = !1);
}
function It() {
  Z = !1, ke = !0;
}
function me(e) {
  if (typeof window == "undefined" || se.get(R(e)))
    return;
  const t = R(e), r = K(e);
  let n = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    Z = !0, n.apply(this, arguments);
  }, r.addEventListener("keydown", ye, !0), r.addEventListener("keyup", ye, !0), r.addEventListener("click", Lt, !0), t.addEventListener("focus", Ct, !0), t.addEventListener("blur", It, !1), typeof PointerEvent != "undefined" ? (r.addEventListener("pointerdown", O, !0), r.addEventListener("pointermove", O, !0), r.addEventListener("pointerup", O, !0)) : (r.addEventListener("mousedown", O, !0), r.addEventListener("mousemove", O, !0), r.addEventListener("mouseup", O, !0)), t.addEventListener("beforeunload", () => {
    Ft(e);
  }, {
    once: !0
  }), se.set(t, {
    focus: n
  });
}
const Ft = (e, t) => {
  const r = R(e), n = K(e);
  t && n.removeEventListener("DOMContentLoaded", t), se.has(r) && (r.HTMLElement.prototype.focus = se.get(r).focus, n.removeEventListener("keydown", ye, !0), n.removeEventListener("keyup", ye, !0), n.removeEventListener("click", Lt, !0), r.removeEventListener("focus", Ct, !0), r.removeEventListener("blur", It, !1), typeof PointerEvent != "undefined" ? (n.removeEventListener("pointerdown", O, !0), n.removeEventListener("pointermove", O, !0), n.removeEventListener("pointerup", O, !0)) : (n.removeEventListener("mousedown", O, !0), n.removeEventListener("mousemove", O, !0), n.removeEventListener("mouseup", O, !0)), se.delete(r));
};
function Ir(e) {
  const t = K(e);
  let r;
  return t.readyState !== "loading" ? me(e) : (r = () => {
    me(e);
  }, t.addEventListener("DOMContentLoaded", r)), () => Ft(e, r);
}
typeof document != "undefined" && Ir();
function Vt() {
  return N !== "pointer";
}
function Fr() {
  return N;
}
function Vr(e) {
  N = e, Ee(e, null);
}
function fn() {
  me();
  let [e, t] = D(N);
  return V(() => {
    let r = () => {
      t(N);
    };
    return de.add(r), () => {
      de.delete(r);
    };
  }, []), ct() ? null : e;
}
const Dr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function kr(e, t, r) {
  var n;
  const a = typeof window != "undefined" ? R(r == null ? void 0 : r.target).HTMLInputElement : HTMLInputElement, l = typeof window != "undefined" ? R(r == null ? void 0 : r.target).HTMLTextAreaElement : HTMLTextAreaElement, o = typeof window != "undefined" ? R(r == null ? void 0 : r.target).HTMLElement : HTMLElement, s = typeof window != "undefined" ? R(r == null ? void 0 : r.target).KeyboardEvent : KeyboardEvent;
  return e = e || (r == null ? void 0 : r.target) instanceof a && !Dr.has(r == null || (n = r.target) === null || n === void 0 ? void 0 : n.type) || (r == null ? void 0 : r.target) instanceof l || (r == null ? void 0 : r.target) instanceof o && (r == null ? void 0 : r.target.isContentEditable), !(e && t === "keyboard" && r instanceof s && !Lr[r.key]);
}
function Kr(e, t, r) {
  me(), V(() => {
    let n = (a, l) => {
      kr(!!(r != null && r.isTextInput), a, l) && e(Vt());
    };
    return de.add(n), () => {
      de.delete(n);
    };
  }, t);
}
function Dt(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: n, onFocusWithinChange: a } = e, l = C({
    isFocusWithin: !1
  }), o = k((c) => {
    l.current.isFocusWithin && !c.currentTarget.contains(c.relatedTarget) && (l.current.isFocusWithin = !1, r && r(c), a && a(!1));
  }, [
    r,
    a,
    l
  ]), s = xt(o), u = k((c) => {
    !l.current.isFocusWithin && document.activeElement === c.target && (n && n(c), a && a(!0), l.current.isFocusWithin = !0, s(c));
  }, [
    n,
    a,
    s
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: u,
      onBlur: o
    }
  };
}
let he = !1, Me = 0;
function Ke() {
  he = !0, setTimeout(() => {
    he = !1;
  }, 50);
}
function nt(e) {
  e.pointerType === "touch" && Ke();
}
function Or() {
  if (typeof document != "undefined")
    return typeof PointerEvent != "undefined" ? document.addEventListener("pointerup", nt) : document.addEventListener("touchend", Ke), Me++, () => {
      Me--, !(Me > 0) && (typeof PointerEvent != "undefined" ? document.removeEventListener("pointerup", nt) : document.removeEventListener("touchend", Ke));
    };
}
function vn(e) {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: n, isDisabled: a } = e, [l, o] = D(!1), s = C({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  V(Or, []);
  let { hoverProps: u, triggerHoverEnd: c } = Y(() => {
    let b = ($, h) => {
      if (s.pointerType = h, a || h === "touch" || s.isHovered || !$.currentTarget.contains($.target))
        return;
      s.isHovered = !0;
      let y = $.currentTarget;
      s.target = y, t && t({
        type: "hoverstart",
        target: y,
        pointerType: h
      }), r && r(!0), o(!0);
    }, g = ($, h) => {
      if (s.pointerType = "", s.target = null, h === "touch" || !s.isHovered)
        return;
      s.isHovered = !1;
      let y = $.currentTarget;
      n && n({
        type: "hoverend",
        target: y,
        pointerType: h
      }), r && r(!1), o(!1);
    }, m = {};
    return typeof PointerEvent != "undefined" ? (m.onPointerEnter = ($) => {
      he && $.pointerType === "mouse" || b($, $.pointerType);
    }, m.onPointerLeave = ($) => {
      !a && $.currentTarget.contains($.target) && g($, $.pointerType);
    }) : (m.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, m.onMouseEnter = ($) => {
      !s.ignoreEmulatedMouseEvents && !he && b($, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, m.onMouseLeave = ($) => {
      !a && $.currentTarget.contains($.target) && g($, "mouse");
    }), {
      hoverProps: m,
      triggerHoverEnd: g
    };
  }, [
    t,
    r,
    n,
    a,
    s
  ]);
  return V(() => {
    a && c({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    a
  ]), {
    hoverProps: u,
    isHovered: l
  };
}
function at(e) {
  if (!e)
    return;
  let t = !0;
  return (r) => {
    let n = I(E({}, r), {
      preventDefault() {
        r.preventDefault();
      },
      isDefaultPrevented() {
        return r.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        t = !1;
      }
    });
    e(n), t && r.stopPropagation();
  };
}
function Hr(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: at(e.onKeyDown),
      onKeyUp: at(e.onKeyUp)
    }
  };
}
function Ar(e) {
  const t = K(e);
  if (Fr() === "virtual") {
    let r = t.activeElement;
    yt(() => {
      t.activeElement === r && e.isConnected && Q(e);
    });
  } else
    Q(e);
}
function pn(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: n } = e, a = C({
    isFocused: !1,
    isFocusVisible: t || Vt()
  }), [l, o] = D(!1), [s, u] = D(() => a.current.isFocused && a.current.isFocusVisible), c = k(() => u(a.current.isFocused && a.current.isFocusVisible), []), b = k(($) => {
    a.current.isFocused = $, o($), c();
  }, [
    c
  ]);
  Kr(($) => {
    a.current.isFocusVisible = $, c();
  }, [], {
    isTextInput: r
  });
  let { focusProps: g } = Mt({
    isDisabled: n,
    onFocusChange: b
  }), { focusWithinProps: m } = Dt({
    isDisabled: !n,
    onFocusWithinChange: b
  });
  return {
    isFocused: l,
    isFocusVisible: s,
    focusProps: n ? m : g
  };
}
let Br = /* @__PURE__ */ B.createContext(null);
function Wr(e) {
  let t = ee(Br) || {};
  mt(t, e);
  let a = t, { ref: r } = a;
  return z(a, ["ref"]);
}
function Ge(e, t) {
  let { focusProps: r } = Mt(e), { keyboardProps: n } = Hr(e), a = A(r, n), l = Wr(t), o = e.isDisabled ? {} : l, s = C(e.autoFocus);
  return V(() => {
    s.current && t.current && Ar(t.current), s.current = !1;
  }, [
    t
  ]), {
    focusableProps: A(I(E({}, a), {
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }), o)
  };
}
function bn(e, t) {
  let {
    elementType: r = "button",
    isDisabled: n,
    onPress: a,
    onPressStart: l,
    onPressEnd: o,
    onPressUp: s,
    onPressChange: u,
    preventFocusOnPress: c,
    allowFocusWhenDisabled: b,
    // @ts-ignore
    onClick: g,
    href: m,
    target: $,
    rel: h,
    type: y = "button"
  } = e, T;
  r === "button" ? T = {
    type: y,
    disabled: n
  } : T = {
    role: "button",
    tabIndex: n ? void 0 : 0,
    href: r === "a" && n ? void 0 : m,
    target: r === "a" ? $ : void 0,
    type: r === "input" ? y : void 0,
    disabled: r === "input" ? n : void 0,
    "aria-disabled": !n || r === "input" ? void 0 : n,
    rel: r === "a" ? h : void 0
  };
  let { pressProps: F, isPressed: x } = De({
    onPressStart: l,
    onPressEnd: o,
    onPressChange: u,
    onPress: a,
    onPressUp: s,
    isDisabled: n,
    preventFocusOnPress: c,
    ref: t
  }), { focusableProps: w } = Ge(e, t);
  b && (w.tabIndex = n ? -1 : w.tabIndex);
  let L = A(w, F, We(e, {
    labelable: !0
  }));
  return {
    isPressed: x,
    buttonProps: A(T, L, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      onClick: (M) => {
        g && (g(M), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
function kt(e, t, r) {
  let { validationBehavior: n, focus: a } = e;
  te(() => {
    if (n === "native" && (r != null && r.current)) {
      let u = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      r.current.setCustomValidity(u), r.current.hasAttribute("title") || (r.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(Rr(r.current));
    }
  });
  let l = H(() => {
    t.resetValidation();
  }), o = H((u) => {
    var c;
    t.displayValidation.isInvalid || t.commitValidation();
    let b = r == null || (c = r.current) === null || c === void 0 ? void 0 : c.form;
    if (!u.defaultPrevented && r && b && jr(b) === r.current) {
      var g;
      a ? a() : (g = r.current) === null || g === void 0 || g.focus(), Vr("keyboard");
    }
    u.preventDefault();
  }), s = H(() => {
    t.commitValidation();
  });
  V(() => {
    let u = r == null ? void 0 : r.current;
    if (!u)
      return;
    let c = u.form;
    return u.addEventListener("invalid", o), u.addEventListener("change", s), c == null || c.addEventListener("reset", l), () => {
      u.removeEventListener("invalid", o), u.removeEventListener("change", s), c == null || c.removeEventListener("reset", l);
    };
  }, [
    r,
    o,
    s,
    l,
    n
  ]);
}
function Ur(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function Rr(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: Ur(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function jr(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let r = e.elements[t];
    if (!r.validity.valid)
      return r;
  }
  return null;
}
const Ne = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, Kt = I(E({}, Ne), {
  customError: !0,
  valid: !1
}), ae = {
  isInvalid: !1,
  validationDetails: Ne,
  validationErrors: []
}, Gr = Ae({}), Oe = "__formValidationState" + Date.now();
function qe(e) {
  if (e[Oe]) {
    let { realtimeValidation: t, displayValidation: r, updateValidation: n, resetValidation: a, commitValidation: l } = e[Oe];
    return {
      realtimeValidation: t,
      displayValidation: r,
      updateValidation: n,
      resetValidation: a,
      commitValidation: l
    };
  }
  return Nr(e);
}
function Nr(e) {
  let { isInvalid: t, validationState: r, name: n, value: a, builtinValidation: l, validate: o, validationBehavior: s = "aria" } = e;
  r && (t || (t = r === "invalid"));
  let u = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: Kt
  } : null, c = Y(() => it(qr(o, a)), [
    o,
    a
  ]);
  l != null && l.validationDetails.valid && (l = null);
  let b = ee(Gr), g = Y(() => n ? Array.isArray(n) ? n.flatMap((p) => He(b[p])) : He(b[n]) : [], [
    b,
    n
  ]), [m, $] = D(b), [h, y] = D(!1);
  b !== m && ($(b), y(!1));
  let T = Y(() => it(h ? [] : g), [
    h,
    g
  ]), F = C(ae), [x, w] = D(ae), L = C(ae), M = () => {
    if (!W)
      return;
    le(!1);
    let p = c || l || F.current;
    Le(p, L.current) || (L.current = p, w(p));
  }, [W, le] = D(!1);
  return V(M), {
    realtimeValidation: u || T || c || l || ae,
    displayValidation: s === "native" ? u || T || x : u || T || c || l || x,
    updateValidation(p) {
      s === "aria" && !Le(x, p) ? w(p) : F.current = p;
    },
    resetValidation() {
      let p = ae;
      Le(p, L.current) || (L.current = p, w(p)), s === "native" && le(!1), y(!0);
    },
    commitValidation() {
      s === "native" && le(!0), y(!0);
    }
  };
}
function He(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function qr(e, t) {
  if (typeof e == "function") {
    let r = e(t);
    if (r && typeof r != "boolean")
      return He(r);
  }
  return [];
}
function it(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: Kt
  } : null;
}
function Le(e, t) {
  return e === t ? !0 : e && t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((r, n) => r === t.validationErrors[n]) && Object.entries(e.validationDetails).every(([r, n]) => t.validationDetails[r] === n);
}
function $n(...e) {
  let t = /* @__PURE__ */ new Set(), r = !1, n = E({}, Ne);
  for (let o of e) {
    var a, l;
    for (let s of o.validationErrors)
      t.add(s);
    r || (r = o.isInvalid);
    for (let s in n)
      (a = n)[l = s] || (a[l] = o.validationDetails[s]);
  }
  return n.valid = !r, {
    isInvalid: r,
    validationErrors: [
      ...t
    ],
    validationDetails: n
  };
}
function _r(e, t, r) {
  let { isDisabled: n = !1, isReadOnly: a = !1, value: l, name: o, children: s, "aria-label": u, "aria-labelledby": c, validationState: b = "valid", isInvalid: g } = e, m = (W) => {
    W.stopPropagation(), t.setSelected(W.target.checked);
  }, $ = s != null, h = u != null || c != null;
  !$ && !h && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: y, isPressed: T } = De({
    isDisabled: n
  }), { pressProps: F, isPressed: x } = De({
    isDisabled: n || a,
    onPress() {
      t.toggle();
    }
  }), { focusableProps: w } = Ge(e, r), L = A(y, w), M = We(e, {
    labelable: !0
  });
  return ht(r, t.isSelected, t.setSelected), {
    labelProps: A(F, {
      onClick: (W) => W.preventDefault()
    }),
    inputProps: A(M, E(I(E({
      "aria-invalid": g || b === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-controls": e["aria-controls"],
      "aria-readonly": a || void 0,
      onChange: m,
      disabled: n
    }, l == null ? {} : {
      value: l
    }), {
      name: o,
      type: "checkbox"
    }), L)),
    isSelected: t.isSelected,
    isPressed: T || x,
    isDisabled: n,
    isReadOnly: a,
    isInvalid: g || b === "invalid"
  };
}
function Xr(e, t, r) {
  let n = qe(I(E({}, e), {
    value: t.isSelected
  })), { isInvalid: a, validationErrors: l, validationDetails: o } = n.displayValidation, { labelProps: s, inputProps: u, isSelected: c, isPressed: b, isDisabled: g, isReadOnly: m } = _r(I(E({}, e), {
    isInvalid: a
  }), t, r);
  kt(e, n, r);
  let { isIndeterminate: $, isRequired: h, validationBehavior: y = "aria" } = e;
  return V(() => {
    r.current && (r.current.indeterminate = !!$);
  }), {
    labelProps: s,
    inputProps: I(E({}, u), {
      checked: c,
      "aria-required": h && y === "aria" || void 0,
      required: h && y === "native"
    }),
    isSelected: c,
    isPressed: b,
    isDisabled: g,
    isReadOnly: m,
    isInvalid: a,
    validationErrors: l,
    validationDetails: o
  };
}
const Yr = /* @__PURE__ */ new WeakMap();
function zr(e) {
  let { id: t, label: r, "aria-labelledby": n, "aria-label": a, labelElementType: l = "label" } = e;
  t = ge(t);
  let o = ge(), s = {};
  r ? (n = n ? `${o} ${n}` : o, s = {
    id: o,
    htmlFor: l === "label" ? t : void 0
  }) : !n && !a && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let u = br({
    id: t,
    "aria-label": a,
    "aria-labelledby": n
  });
  return {
    labelProps: s,
    fieldProps: u
  };
}
function Qr(e) {
  let { description: t, errorMessage: r, isInvalid: n, validationState: a } = e, { labelProps: l, fieldProps: o } = zr(e), s = ze([
    !!t,
    !!r,
    n,
    a
  ]), u = ze([
    !!t,
    !!r,
    n,
    a
  ]);
  return o = A(o, {
    "aria-describedby": [
      s,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      u,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: l,
    fieldProps: o,
    descriptionProps: {
      id: s
    },
    errorMessageProps: {
      id: u
    }
  };
}
function Jr(e = {}) {
  let { isReadOnly: t } = e, [r, n] = Pt(e.isSelected, e.defaultSelected || !1, e.onChange);
  function a(o) {
    t || n(o);
  }
  function l() {
    t || n(!r);
  }
  return {
    isSelected: r,
    setSelected: a,
    toggle: l
  };
}
function gn(e, t, r) {
  const n = Jr({
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isSelected: t.isSelected(e.value),
    onChange(T) {
      T ? t.addValue(e.value) : t.removeValue(e.value), e.onChange && e.onChange(T);
    }
  });
  let { name: a, descriptionId: l, errorMessageId: o, validationBehavior: s } = Yr.get(t);
  var u;
  s = (u = e.validationBehavior) !== null && u !== void 0 ? u : s;
  let { realtimeValidation: c } = qe(I(E({}, e), {
    value: n.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  })), b = C(ae), g = () => {
    t.setInvalid(e.value, c.isInvalid ? c : b.current);
  };
  V(g);
  let m = t.realtimeValidation.isInvalid ? t.realtimeValidation : c, $ = s === "native" ? t.displayValidation : m;
  var h;
  let y = Xr(I(E({}, e), {
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isDisabled: e.isDisabled || t.isDisabled,
    name: e.name || a,
    isRequired: (h = e.isRequired) !== null && h !== void 0 ? h : t.isRequired,
    validationBehavior: s,
    [Oe]: {
      realtimeValidation: m,
      displayValidation: $,
      resetValidation: t.resetValidation,
      commitValidation: t.commitValidation,
      updateValidation(T) {
        b.current = T, g();
      }
    }
  }), n, r);
  return I(E({}, y), {
    inputProps: I(E({}, y.inputProps), {
      "aria-describedby": [
        e["aria-describedby"],
        t.isInvalid ? o : null,
        l
      ].filter(Boolean).join(" ") || void 0
    })
  });
}
const ot = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function Zr(e = {}) {
  let { style: t, isFocusable: r } = e, [n, a] = D(!1), { focusWithinProps: l } = Dt({
    isDisabled: !r,
    onFocusWithinChange: (s) => a(s)
  }), o = Y(() => n ? t : t ? E(E({}, ot), t) : ot, [
    n
  ]);
  return {
    visuallyHiddenProps: I(E({}, l), {
      style: o
    })
  };
}
function yn(e) {
  let s = e, { children: t, elementType: r = "div", isFocusable: n, style: a } = s, l = z(s, ["children", "elementType", "isFocusable", "style"]), { visuallyHiddenProps: o } = Zr(e);
  return /* @__PURE__ */ B.createElement(r, A(l, o), t);
}
function mn(e, t) {
  let { inputElementType: r = "input", isDisabled: n = !1, isRequired: a = !1, isReadOnly: l = !1, type: o = "text", validationBehavior: s = "aria" } = e, [u, c] = Pt(e.value, e.defaultValue || "", e.onChange), { focusableProps: b } = Ge(e, t), g = qe(I(E({}, e), {
    value: u
  })), { isInvalid: m, validationErrors: $, validationDetails: h } = g.displayValidation, { labelProps: y, fieldProps: T, descriptionProps: F, errorMessageProps: x } = Qr(I(E({}, e), {
    isInvalid: m,
    errorMessage: e.errorMessage || $
  })), w = We(e, {
    labelable: !0
  });
  const L = {
    type: o,
    pattern: e.pattern
  };
  return ht(t, u, c), kt(e, g, t), V(() => {
    if (t.current instanceof R(t.current).HTMLTextAreaElement) {
      let M = t.current;
      Object.defineProperty(M, "defaultValue", {
        get: () => M.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    t
  ]), {
    labelProps: y,
    inputProps: A(w, r === "input" ? L : void 0, E(E({
      disabled: n,
      readOnly: l,
      required: a && s === "native",
      "aria-required": a && s === "aria" || void 0,
      "aria-invalid": m || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-activedescendant": e["aria-activedescendant"],
      "aria-autocomplete": e["aria-autocomplete"],
      "aria-haspopup": e["aria-haspopup"],
      value: u,
      onChange: (M) => c(M.target.value),
      autoComplete: e.autoComplete,
      autoCapitalize: e.autoCapitalize,
      maxLength: e.maxLength,
      minLength: e.minLength,
      name: e.name,
      placeholder: e.placeholder,
      inputMode: e.inputMode,
      // Clipboard events
      onCopy: e.onCopy,
      onCut: e.onCut,
      onPaste: e.onPaste,
      // Composition events
      onCompositionEnd: e.onCompositionEnd,
      onCompositionStart: e.onCompositionStart,
      onCompositionUpdate: e.onCompositionUpdate,
      // Selection events
      onSelect: e.onSelect,
      // Input events
      onBeforeInput: e.onBeforeInput,
      onInput: e.onInput
    }, b), T)),
    descriptionProps: F,
    errorMessageProps: x,
    isInvalid: m,
    validationErrors: $,
    validationDetails: h
  };
}
const en = (e, t) => t.some((r) => r.seoId === e.seoId), hn = (e, t) => e.filter((r) => !en(r, t)), Pn = (e, t = [], r) => e ? [...t, r] : t.filter((n) => n !== r);
function En(e) {
  return e;
}
const Ot = lt((a, n) => {
  var l = a, { className: e, as: t } = l, r = z(l, ["className", "as"]);
  const o = t || "div", { styleProps: s, other: u } = st(r), c = dt(s), b = E({}, u);
  return o !== Ut && (b.className = e || c.length ? Be(e, c) : void 0), /* @__PURE__ */ Ce.jsx(o, I(E({}, b), { ref: n }));
});
Ot.displayName = "Element";
const Tn = Ot, wn = (e, t) => {
  const r = e[t];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((n, a) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(a.bind(null, new Error("Unknown variable dynamic import: " + t)));
  });
}, tn = Ae({
  isDevFormikOnChange: !1,
  isFormikFieldWrapped: !1
}), Ht = lt((a, n) => {
  var l = a, { className: e, as: t } = l, r = z(l, ["className", "as"]);
  const { styleProps: o, other: s } = st(r), u = dt(o), c = E({
    ref: n,
    className: Be(e, u)
  }, s);
  return /* @__PURE__ */ Ce.jsx(tn.Provider, { value: { isDevFormikOnChange: !!r.onChange, isFormikFieldWrapped: !0 }, children: /* @__PURE__ */ Ce.jsx(Rt, E({ as: t != null ? t : "input" }, c)) });
});
Ht.displayName = "Field";
const Sn = Ht;
export {
  ge as $,
  ct as A,
  hr as B,
  $t as C,
  Fr as D,
  Tn as E,
  tn as F,
  Q as G,
  J as H,
  Pt as I,
  Ge as J,
  We as K,
  un as L,
  fr as M,
  ze as N,
  br as O,
  Yr as P,
  Dt as Q,
  zr as R,
  Vr as S,
  Hr as T,
  ht as U,
  dr as V,
  Re as W,
  Vt as X,
  Mt as Y,
  Oe as Z,
  wn as _,
  cn as a,
  fn as a0,
  dn as a1,
  kt as a2,
  Zr as a3,
  _r as a4,
  qe as a5,
  $n as a6,
  Ne as a7,
  hn as a8,
  sn as a9,
  Sn as aa,
  bn as b,
  En as c,
  pn as d,
  vn as e,
  A as f,
  yn as g,
  gn as h,
  Xr as i,
  Jr as j,
  Qr as k,
  mn as l,
  Pn as m,
  ft as n,
  te as o,
  H as p,
  ln as q,
  oe as r,
  Et as s,
  K as t,
  pr as u,
  fe as v,
  Je as w,
  De as x,
  R as y,
  Ar as z
};
//# sourceMappingURL=field-2ca69145.js.map
